import { memo, useState } from "react";
import { FaDollarSign } from "react-icons/fa";
import "../CashForDeed.css";

const CfdPropertyTags = ({ item, activeTab }) => {
  const isSavedTab = activeTab === "saved";
  const [showTooltip, setShowTooltip] = useState(false);

  // Destructuring and conditional checking for the values
  const { fcOnlineFlag, sellerId } = item;
  const category = isSavedTab
    ? item?.propertyDetails?.commonAttributes?.propCategory
    : item?.category;
  const newToHubzuFlag = isSavedTab
    ? item?.propertyListingDetails?.isNewToHubzuFlag
    : item?.newToHubzuFlag;
  const isNewToHubzu = isSavedTab
    ? item?.propertyListingDetails?.isNewToHubzuFlag
    : item?.isNewToHubzu;
  const isNoBuyerPremium = isSavedTab
    ? item?.propertyListingDetails?.isNoBuyerPremium
    : item?.isNoBuyerPremium;

  // Define the labels and colors
  const label = {
    REO: "BANK-OWNED",
    NPL: "NON-PERFORMING LOAN",
    SC: sellerId !== "501" ? "CWCOT SECOND CHANCE" : "BANK-OWNED",
    NON_REO: "NON-BANK OWNED",
    FORECLOSURE: fcOnlineFlag === "Y" ? "ONLINE FORECLOSURE" : "FORECLOSURE",
    SHRT_SALE: "SHORT SALE",
    ABS: "BANK-OWNED",
    CFD: "CASH FOR DEED",
  };

  const color = {
    REO: "rgb(255, 121, 0)",
    NPL: "rgb(255, 121, 0)",
    SC: "rgb(255, 121, 0)",
    NON_REO: "rgb(99, 147, 142)",
    FORECLOSURE: "rgb(143, 176, 53)",
    SHRT_SALE: "rgb(99, 147, 142)",
    CFD: "rgb(72, 192, 56)",
  };

  // Helper function to check for valid flags
  const isValidFlag = (flag) =>
    flag && flag !== "0" && flag !== null && flag !== undefined;

  return (
    <div className="d-flex">
      <ul className="cfd-tags mb0">
        {/* Display CFD tag */}
        <li className="cfd-list-inline-item">
          <a href="#" className="cfd-tag-badge">
            <div
              className="cfd-tag-dot"
              style={{ backgroundColor: color["CFD"] }}
            />
            <div>{label["CFD"]}</div>
          </a>
        </li>

        {/* Display 'NEW' tag if either flag is valid */}
        {/* {(isValidFlag(newToHubzuFlag) || isValidFlag(isNewToHubzu)) && (
        <li className="list-inline-item cfd-new-tag">
          <a href="#" className="text-capitalize">
            NEW
          </a>
        </li>
      )} */}

        {/* Display 'No Buyer's Premium' tag if valid */}
      </ul>
      {/* {isValidFlag(isNoBuyerPremium) && (
        <div
          className="premium-icon"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <FaDollarSign className="text-primary" />
          {showTooltip && (
            <div className="premium-tooltip">No Buyer's Premium</div>
          )}
        </div>
      )} */}
    </div>
  );
};

export default memo(CfdPropertyTags);
